import { httpsCallable } from 'firebase/functions';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, functions } from './config';

const waitForCurrentUser = () => new Promise((resolve) => {
  if (auth.currentUser) {
    resolve(auth.currentUser);
    return;
  }

  const unsubscribe = onAuthStateChanged(auth, (user) => {
    unsubscribe();
    resolve(user);
  });
});

export const sendCustomVerificationEmail = async (continuePath = '/') => {
  const user = await waitForCurrentUser();
  if (user) {
    await user.getIdToken(true);
  }

  const callable = httpsCallable(functions, 'sendCustomVerificationEmail');
  try {
    const result = await callable({ continuePath });
    return result.data;
  } catch (error) {
    if (error?.code === 'functions/unauthenticated' || error?.code === 'functions/permission-denied') {
      await new Promise((resolve) => setTimeout(resolve, 750));
      const retryUser = await waitForCurrentUser();
      if (retryUser) {
        await retryUser.getIdToken(true);
      }
      const retryResult = await callable({ continuePath });
      return retryResult.data;
    }
    throw error;
  }
};

export const sendCustomPasswordResetEmail = async (email, continuePath = '/login') => {
  const callable = httpsCallable(functions, 'sendCustomPasswordResetEmail');
  const result = await callable({ email, continuePath });
  return result.data;
};
